export const PERMISSIONS = {
  USERS_VIEW: "users.view",

  CONTACTS: {
    VIEW: "contacts.view",
    CREATE: "contacts.create",
    UPDATE: "contacts.update",
    DELETE: "contacts.delete",
    IMAGE_UPDATE: "contacts.image.update",
  },
  CONTACT_CATEGORIES_VIEW: "contact_categories.view",

  COMPANIES: {
    VIEW: "companies.view",
    CREATE: "companies.create",
    UPDATE: "companies.update",
    DELETE: "companies.delete",
    IMAGE_UPDATE: "companies.image.update",
  },

  BANKS_VIEW: "banks.view",

  ITEMS: {
    VIEW: "items.view",
    CREATE: "items.create",
    UPDATE: "items.update",
    DELETE: "items.delete",
    IMAGE_UPDATE: "items.image.update",
  },
  UNITS_VIEW: "units.view",

  PHASES_VIEW: "phases.view",
  SUBPHASES_VIEW: "subphases.view",
  PHASES_BY_PROPERTY_TYPE_VIEW: "phases.by_property_type.view",
  PROPERTY_TYPES_VIEW: "property_types.view",

  PROPERTIES: {
    VIEW: "properties.view",
    CREATE: "properties.create",
    UPDATE: "properties.update",
    DELETE: "properties.delete",
    IMAGES_VIEW: "properties.images.view",
    IMAGES_UPLOAD: "properties.images.upload",
    IMAGES_DELETE: "properties.images.delete",
    NOTES_UPDATE: "properties.notes.update",
    CONTACTS_ASSIGN: "properties.contacts.assign",
    CONTACTS_UNASSIGN: "properties.contacts.unassign",
    COMPANIES_ASSIGN: "properties.companies.assign",
    COMPANIES_UNASSIGN: "properties.companies.unassign",
  },

  PROCESSES: {
    VIEW: "processes.view",
    PROPERTY_STATUS_VIEW: "processes.property_status.view",
    PROPERTY_STATUS_UPDATE: "processes.property_status.update",
  },

  TASKS: {
    VIEW: "tasks.view",
    CREATE: "tasks.create",
    UPDATE: "tasks.update",
    DELETE: "tasks.delete",
  },
};

